import { input, output } from '@angular/core';
import { SimpleModalFooterComponent } from 'Angular/features/components/modals/modal-base/components/simple-modal-footer.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = (a0, a1, a2) => ({ "btn-success": a0, "btn-ghost btn-outline": a1, "disabled": a2 });
const _c1 = a0 => ({ "disabled": a0 });
function StartRTQModalFooterComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function StartRTQModalFooterComponent_Conditional_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancelHandler.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.cancelButtonText);
} }
function StartRTQModalFooterComponent_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function StartRTQModalFooterComponent_Conditional_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.cancelHandler.emit()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.cancelButtonText);
} }
function StartRTQModalFooterComponent_Conditional_5_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 8);
} }
function StartRTQModalFooterComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function StartRTQModalFooterComponent_Conditional_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submitEvent.emit(true)); });
    i0.ɵɵconditionalCreate(1, StartRTQModalFooterComponent_Conditional_5_Conditional_1_Template, 1, 0, ":svg:svg", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disableSubmission)("ngClass", i0.ɵɵpureFunction3(4, _c0, ctx_r1.asyncCreated(), !ctx_r1.asyncCreated(), ctx_r1.disableSubmission));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.asyncCreated() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.asyncCreated() ? "Copied" : "Copy Link");
} }
function StartRTQModalFooterComponent_Conditional_6_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "div", 11);
    i0.ɵɵelementEnd();
} }
function StartRTQModalFooterComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function StartRTQModalFooterComponent_Conditional_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.submitEvent.emit(false)); });
    i0.ɵɵconditionalCreate(1, StartRTQModalFooterComponent_Conditional_6_Conditional_1_Template, 2, 0, "div", 10);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.disableSubmission)("ngClass", i0.ɵɵpureFunction1(5, _c1, ctx_r1.disableSubmission));
    i0.ɵɵattribute("data-test-id", ctx_r1.modalTestId ? ctx_r1.modalTestId + "-submit-button" : ctx_r1.submitButtonText);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loading ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.submitButtonText);
} }
/**
 *
 * Start RTQ Modal Footer Component
 *
 *  Input properties:
 * - submitEventLayout: control layout of buttons
 * - asyncCreated: control classes and text for 'Copy Link' button
 *
 *  Output properties:
 * - submitEvent: override for submitHandler to emit boolean value if its async flow or not
 */
export class StartRTQModalFooterComponent extends SimpleModalFooterComponent {
    constructor() {
        super(...arguments);
        this.submitEventLayout = input.required(...(ngDevMode ? [{ debugName: "submitEventLayout" }] : []));
        this.asyncCreated = input.required(...(ngDevMode ? [{ debugName: "asyncCreated" }] : []));
        this.submitEvent = output();
    }
}
StartRTQModalFooterComponent.ɵfac = /*@__PURE__*/ (() => { let ɵStartRTQModalFooterComponent_BaseFactory; return function StartRTQModalFooterComponent_Factory(__ngFactoryType__) { return (ɵStartRTQModalFooterComponent_BaseFactory || (ɵStartRTQModalFooterComponent_BaseFactory = i0.ɵɵgetInheritedFactory(StartRTQModalFooterComponent)))(__ngFactoryType__ || StartRTQModalFooterComponent); }; })();
StartRTQModalFooterComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StartRTQModalFooterComponent, selectors: [["ycn-start-rtq-modal-footer"]], inputs: { submitEventLayout: [1, "submitEventLayout"], asyncCreated: [1, "asyncCreated"] }, outputs: { submitEvent: "submitEvent" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 7, vars: 3, consts: [[1, "modal-footer", "user-select-none"], [1, "modal-footer-info"], ["type", "button", 1, "btn", "btn-text", 3, "textContent"], [1, "modal-footer-actions"], ["ycnDisabled", "", "type", "button", 1, "btn", 3, "disabled", "ngClass"], ["type", "button", "tabindex", "0", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "disabled", "ngClass"], ["type", "button", 1, "btn", "btn-text", 3, "click", "textContent"], ["ycnDisabled", "", "type", "button", 1, "btn", 3, "click", "disabled", "ngClass"], ["ycnIcon", "", "name", "icon-check", 1, "fill-current"], ["type", "button", "tabindex", "0", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled", "ngClass"], [1, "mr-1"], [1, "loader-spinner-context", "loader-xs", "white"]], template: function StartRTQModalFooterComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵconditionalCreate(2, StartRTQModalFooterComponent_Conditional_2_Template, 1, 1, "button", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵconditionalCreate(4, StartRTQModalFooterComponent_Conditional_4_Template, 1, 1, "button", 2)(5, StartRTQModalFooterComponent_Conditional_5_Template, 3, 8, "button", 4);
        i0.ɵɵconditionalCreate(6, StartRTQModalFooterComponent_Conditional_6_Template, 4, 7, "button", 5);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.submitEventLayout() ? 2 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(!ctx.submitEventLayout() ? 4 : 5);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.showSubmitButton ? 6 : -1);
    } }, dependencies: [i1.DisabledDirective, i2.NgClass, i3.IconDirective], encapsulation: 2 });
